<template>
    <span class="text-primary">
        <i
            class="fa fa-download fa-lg icon-button"
            title="Download"
            @click.stop="downloadNotaFiscal()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        pagamentoNotaFiscal: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    methods: {
        downloadNotaFiscal() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .downloadNotaFiscal(this.pagamentoNotaFiscal.pagamentoNotaFiscalId)
                .then(response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao realizar download da nota fiscal!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(
                                response,
                                this.pagamentoNotaFiscal.nomeArquivo
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    }
}
</script>
